import { j as r } from "./jsx-runtime.DGlMoOmv.js";
import * as s from "react";
const a = (o, t) => /* @__PURE__ */ r.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "currentColor", viewBox: "0 0 16 16", ref: t, ...o, children: /* @__PURE__ */ r.jsx("path", { fill: "currentColor", d: "M12.854 5.15a.5.5 0 0 1 0 .706l-6 6a.5.5 0 0 1-.708 0l-3-3.003a.5.5 0 1 1 .708-.706L6.5 10.796l5.646-5.647a.5.5 0 0 1 .708 0Z" }) }), l = s.forwardRef(a);
export {
  l as F
};
//# sourceMappingURL=Check16.D3hXRfGO.js.map
